import { i18next } from '@yola/ws-sdk';
import linkTypes from '../constants/link-types';

const getLinkTypeOptions = (types) => {
  const options = [
    {
      label: i18next.t('Open a page'),
      value: linkTypes.PAGE,
    },
    {
      label: i18next.t('Scroll to a block'),
      value: linkTypes.ANCHOR,
    },
    {
      label: i18next.t('Open a web address'),
      value: linkTypes.EXTERNAL,
    },
    {
      label: i18next.t('Make a phone call'),
      value: linkTypes.PHONE,
    },
    {
      label: i18next.t('Send an email'),
      value: linkTypes.MAIL,
    },
    {
      label: i18next.t('Download a file'),
      value: linkTypes.DOWNLOAD,
    },
    {
      label: i18next.t('Connect to CMS'),
      value: linkTypes.BINDING,
    },
  ].filter((option) => types.includes(option.value));

  return [
    {
      label: i18next.t('Select an action'),
      options,
    },
  ];
};

export default getLinkTypeOptions;
